<template>
  <!-- Page Header -->
  <div class="page-header">
    <div class="row align-items-center">
      <div class="col-1 mr-n5">
        <a @click="$router.back()">
          <i class="fa-solid fa-circle-arrow-left fa-2x"></i>
        </a>
      </div>
      <div class="col-auto">
        <h3 class="page-title">{{ title }}</h3>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            {{ path }}
            <!-- <router-link to="/employee/list-employee">{{ path }}</router-link> -->
          </li>
          <li class="breadcrumb-item active">{{ text }}</li>
        </ul>
      </div>
      <div class="col-auto ms-auto">
        <div class="employees-header-actions">
          <router-link
            v-if="
              userPermissions.length &&
              userPermissions.includes('employee-create')
            "
            to="/employee/bulk-employee-profile"
            class="btn add-btn header-btn-primary"
            ><!--<i class="fa-regular fa-image"></i>--> Bulk Upload Profile Images</router-link
          >
          <router-link
            v-if="
              userPermissions.length &&
              userPermissions.includes('employee-edit')
            "
            to="/employee/bulk-employee-update"
            class="btn add-btn header-btn-primary"
            ><!--<i class="fa-solid fa-pen-to-square"></i>--> Bulk Update</router-link
          >
          <router-link
            v-if="
              userPermissions.length &&
              userPermissions.includes('employee-create')
            "
            to="/employee/bulk-employee-add"
            class="btn add-btn header-btn-primary"
            ><!--<i class="fa-solid fa-users"></i>--> Bulk Add</router-link
          >
          <router-link
            v-if="
              userPermissions.length &&
              userPermissions.includes('employee-create') &&
              text1
            "
            class="btn add-btn header-btn-primary"
            to="/employee/create-employee"
            ><i class="fa-solid fa-plus"></i> {{ text1 }}</router-link
          >
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Header -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userPermissions: [],
    };
  },
  created() {
    this.userPermissions =
      this.$store._state?.data?.auth?.user?.permission?.map((el) => el.name) ||
      [];
  },
};
</script>

<style scoped>
.employees-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.employees-header-actions .btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  margin: 0 !important;
  float: none !important;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  border-radius: 8px;
}
/* secondary: outline, quiet until hovered */
.employees-header-actions .header-btn-secondary {
  background: #fff;
  color: #344054;
  border: 1px solid #dfe3ea;
}
.employees-header-actions .header-btn-secondary i {
  font-size: 13px;
  color: #667085;
  transition: color 0.15s ease;
}
.employees-header-actions .header-btn-secondary:hover,
.employees-header-actions .header-btn-secondary:focus {
  background: #f5f6f8;
  border-color: #c9cfd9;
  color: #1d2939;
}
.employees-header-actions .header-btn-secondary:hover i {
  color: var(--primary-color);
}
</style>
